export const getCartProductsDetailsFromJSON = (dispatch) => {
  var response = require('../containers/Cart/sampleCartProductDetailsJson.json');
  dispatch({
    type: 'CARTPRODUCTSDETAILSFROMJSON',
    value: response.data.prodAccessoryList,
    subTotal: response.data.Subtotal,
    total: response.data.Total,
    shippingcrg: response.data.Shippingcharge,
    tax: response.data.Tax,
  });
  return response;
};

export const showCart = (hideCart, dispatch) => {
  var response = hideCart;
  dispatch({ type: 'SHOWCART', value: !response });
  return response;
};
